// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var MM_wrk_client = require("../worker/MM_wrk_client.res.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var Expln_React_Menu = require("../../rescript-utils/main/react-mui-components/Expln_React_Menu.res.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.res.js");
var MM_cmp_rename_tab = require("../ui/MM_cmp_rename_tab.res.js");
var Belt_HashSetString = require("rescript/lib/js/belt_HashSetString.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var MM_wrk_search_asrt = require("../worker/MM_wrk_search_asrt.res.js");
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.res.js");
var Button = require("@mui/material/Button").default;
var Select = require("@mui/material/Select").default;
var MM_cmp_pe_frame_list = require("./MM_cmp_pe_frame_list.res.js");
var MM_cmp_asrts_per_page = require("./MM_cmp_asrts_per_page.res.js");
var Checkbox = require("@mui/material/Checkbox").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var Menu = require("@mui/icons-material/Menu").default;
var IconButton = require("@mui/material/IconButton").default;
var InputLabel = require("@mui/material/InputLabel").default;
var FormControl = require("@mui/material/FormControl").default;
var FilterAlt = require("@mui/icons-material/FilterAlt").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;
var FilterAltOff = require("@mui/icons-material/FilterAltOff").default;

function propsAreSame(a, b) {
  if (a.preCtxData === b.preCtxData && a.ctxSelectorIsExpanded === b.ctxSelectorIsExpanded) {
    return a.tabTitle === b.tabTitle;
  } else {
    return false;
  }
}

var make = React.memo((function (param) {
        var onTabTitleChange = param.onTabTitleChange;
        var addAsrtByLabel = param.addAsrtByLabel;
        var initPatternFilterStr = param.initPatternFilterStr;
        var ctxSelectorIsExpanded = param.ctxSelectorIsExpanded;
        var toggleCtxSelector = param.toggleCtxSelector;
        var openExplorer = param.openExplorer;
        var tabTitle = param.tabTitle;
        var preCtxData = param.preCtxData;
        var modalRef = param.modalRef;
        var match = React.useState(function () {
              if (preCtxData.srcs.length === 0) {
                return ;
              } else {
                return preCtxData.ctxV.ver;
              }
            });
        var setLastNonEmptyPreCtxVer = match[1];
        var lastNonEmptyPreCtxVer = match[0];
        var match$1 = React.useState(function () {
              return false;
            });
        var setRefreshIsNeeded = match$1[1];
        var refreshIsNeeded = match$1[0];
        var match$2 = React.useState(function () {
              return false;
            });
        var setApplyFiltersRequested = match$2[1];
        var applyFiltersRequested = match$2[0];
        var match$3 = React.useState(function () {
              return [];
            });
        var setAllFramesInDeclarationOrder = match$3[1];
        var allFramesInDeclarationOrder = match$3[0];
        var match$4 = React.useState(function () {
              return [];
            });
        var setAllStmtTypes = match$4[1];
        var allStmtTypes = match$4[0];
        var match$5 = React.useState(function () {
              return "all";
            });
        var setAllStmtTypesConcat = match$5[1];
        var allStmtTypesConcat = match$5[0];
        var match$6 = React.useState(function () {
              
            });
        var setIsAxiomFilter = match$6[1];
        var isAxiomFilter = match$6[0];
        var match$7 = React.useState(function () {
              
            });
        var setStmtTypeFilter = match$7[1];
        var stmtTypeFilter = match$7[0];
        var match$8 = React.useState(function () {
              return "";
            });
        var setLabelFilter = match$8[1];
        var labelFilter = match$8[0];
        var match$9 = React.useState(function () {
              return initPatternFilterStr;
            });
        var setPatternFilterStr = match$9[1];
        var patternFilterStr = match$9[0];
        var match$10 = React.useState(function () {
              
            });
        var setPatternFilterErr = match$10[1];
        var patternFilterErr = match$10[0];
        var match$11 = React.useState(function () {
              return "";
            });
        var setDescrFilterStr = match$11[1];
        var descrFilterStr = match$11[0];
        var match$12 = React.useState(function () {
              
            });
        var setDiscFilter = match$12[1];
        var discFilter = match$12[0];
        var match$13 = React.useState(function () {
              
            });
        var setDeprFilter = match$13[1];
        var deprFilter = match$13[0];
        var match$14 = React.useState(function () {
              
            });
        var setTranDeprFilter = match$14[1];
        var tranDeprFilter = match$14[0];
        var match$15 = React.useState(function () {
              return [];
            });
        var setFilteredLabels = match$15[1];
        var match$16 = React.useState(function () {
              return false;
            });
        var setMainMenuIsOpened = match$16[1];
        var mainMenuIsOpened = match$16[0];
        var mainMenuButtonRef = React.useRef(null);
        var match$17 = Local_storage_utils.useStateFromLocalStorageInt("pe-index-asrts-per-page", 10);
        var setAsrtsPerPage = match$17[1];
        var asrtsPerPage = match$17[0];
        var filterByDescr = function (frames) {
          var descrFilterStrNorm = MM_context.normalizeDescr(descrFilterStr);
          if (descrFilterStrNorm.length > 0) {
            return frames.filter(function (frame) {
                        return Belt_Option.mapWithDefault(frame.descrNorm, false, (function (descrNorm) {
                                      return descrNorm.includes(descrFilterStrNorm);
                                    }));
                      });
          } else {
            return frames;
          }
        };
        var makeActTerminate = function (modalId) {
          return function () {
            MM_wrk_client.terminateWorker();
            Expln_React_Modal.closeModal(modalRef, modalId);
          };
        };
        var actPreCtxDataChanged = function () {
          var preCtx = preCtxData.ctxV.val.full;
          var allFramesInDeclarationOrder = Expln_utils_common.sortInPlaceWith(Belt_MapString.valuesToArray(MM_context.getAllFrames(preCtx)), (function (a, b) {
                  return a.ord - b.ord | 0;
                }));
          setAllFramesInDeclarationOrder(function (param) {
                return allFramesInDeclarationOrder;
              });
          setFilteredLabels(function (param) {
                return allFramesInDeclarationOrder.map(function (frame) {
                            return frame.label;
                          });
              });
          var allStmtIntTypes = [];
          MM_context.forEachFrame(preCtx, (function (frame) {
                  var stmtTyp = frame.asrt[0];
                  if (!allStmtIntTypes.includes(stmtTyp)) {
                    allStmtIntTypes.push(stmtTyp);
                  }
                  
                }));
          var allStmtTypes = MM_context.ctxIntsToSymsExn(preCtx, allStmtIntTypes).sort();
          setAllStmtTypes(function (param) {
                return allStmtTypes;
              });
          setAllStmtTypesConcat(function (param) {
                return "all" + allStmtTypes.join("");
              });
          setStmtTypeFilter(function (typ) {
                return Core__Option.flatMap(Core__Option.flatMap(typ, (function (__x) {
                                  return MM_context.ctxSymToInt(preCtx, __x);
                                })), (function (__x) {
                              return MM_context.ctxIntToSym(preCtx, __x);
                            }));
              });
          setApplyFiltersRequested(function (param) {
                return true;
              });
        };
        var actRefreshOnPreCtxDataChange = function () {
          actPreCtxDataChanged();
          setLastNonEmptyPreCtxVer(function (param) {
                return preCtxData.ctxV.ver;
              });
          setRefreshIsNeeded(function (param) {
                return false;
              });
        };
        var actApplyFilters = function () {
          if (refreshIsNeeded) {
            return actRefreshOnPreCtxDataChange();
          }
          setApplyFiltersRequested(function (param) {
                return false;
              });
          var searchPattern = MM_wrk_search_asrt.makeSearchPattern(patternFilterStr.trim(), preCtxData.ctxV.val.full);
          if (searchPattern.TAG === "Ok") {
            var searchPattern$1 = searchPattern._0;
            setPatternFilterErr(function (param) {
                  
                });
            if (searchPattern$1.length === 0) {
              return setFilteredLabels(function (param) {
                          var frames = filterByDescr(MM_wrk_search_asrt.doSearchAssertions(allFramesInDeclarationOrder, isAxiomFilter, Core__Option.map(stmtTypeFilter, (function (typ) {
                                          return Core__Option.getExn(MM_context.ctxSymToInt(preCtxData.ctxV.val.full, typ), "Cannot convert symbol '" + typ + "' to int in MM_cmp_pe_index.actApplyFilters[1].");
                                        })), labelFilter, [], discFilter, deprFilter, tranDeprFilter, undefined));
                          return frames.map(function (frame) {
                                      return frame.label;
                                    });
                        });
            } else {
              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                          return MM_react_common.rndProgress("Searching", 0, undefined);
                        })), (function (modalId) {
                      Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                              return MM_react_common.rndProgress("Searching", 0, makeActTerminate(modalId));
                            }));
                      return Expln_utils_promise.promiseMap(MM_wrk_search_asrt.searchAssertions(preCtxData.settingsV.ver, preCtxData.settingsV.val, preCtxData.ctxV.ver, preCtxData.ctxV.val.min, isAxiomFilter, Core__Option.map(stmtTypeFilter, (function (typ) {
                                            return Core__Option.getExn(MM_context.ctxSymToInt(preCtxData.ctxV.val.full, typ), "Cannot convert symbol '" + typ + "' to int in MM_cmp_pe_index.actApplyFilters[2].");
                                          })), labelFilter, searchPattern$1, discFilter, deprFilter, tranDeprFilter, (function (pct) {
                                        Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                                return MM_react_common.rndProgress("Searching", pct, makeActTerminate(modalId));
                                              }));
                                      })), (function (foundLabels) {
                                    var foundLabelsSet = Belt_HashSetString.fromArray(foundLabels);
                                    setFilteredLabels(function (param) {
                                          var frames = filterByDescr(allFramesInDeclarationOrder.filter(function (frame) {
                                                    return Belt_HashSetString.has(foundLabelsSet, frame.label);
                                                  }));
                                          return frames.map(function (frame) {
                                                      return frame.label;
                                                    });
                                        });
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }));
                    }));
              return ;
            }
          }
          var msg = searchPattern._0;
          setPatternFilterErr(function (param) {
                return msg;
              });
        };
        React.useEffect((function () {
                if (applyFiltersRequested) {
                  setApplyFiltersRequested(function (param) {
                        return false;
                      });
                  actApplyFilters();
                }
                
              }), [applyFiltersRequested]);
        React.useEffect((function () {
                if (lastNonEmptyPreCtxVer !== undefined) {
                  if (lastNonEmptyPreCtxVer === preCtxData.ctxV.ver) {
                    actPreCtxDataChanged();
                  } else {
                    setRefreshIsNeeded(function (param) {
                          return true;
                        });
                    setApplyFiltersRequested(function (param) {
                          return false;
                        });
                  }
                } else {
                  setLastNonEmptyPreCtxVer(function (param) {
                        if (preCtxData.srcs.length === 0) {
                          return ;
                        } else {
                          return preCtxData.ctxV.ver;
                        }
                      });
                  actPreCtxDataChanged();
                }
              }), [preCtxData]);
        var isAxiomFilterToStr = function (typeFilter) {
          if (typeFilter !== undefined) {
            if (typeFilter) {
              return "true";
            } else {
              return "false";
            }
          } else {
            return "none";
          }
        };
        var actIsAxiomFilterUpdated = function (isAxiomStr) {
          setIsAxiomFilter(function (param) {
                switch (isAxiomStr) {
                  case "false" :
                      return false;
                  case "true" :
                      return true;
                  default:
                    return ;
                }
              });
        };
        var actStmtTypeFilterUpdated = function (stmtTypeStr) {
          var ctx = preCtxData.ctxV.val.full;
          setStmtTypeFilter(function (param) {
                return Core__Option.flatMap(MM_context.ctxSymToInt(ctx, stmtTypeStr), (function (__x) {
                              return MM_context.ctxIntToSym(ctx, __x);
                            }));
              });
        };
        var actLabelFilterUpdated = function (newLabelFilter) {
          setLabelFilter(function (param) {
                return newLabelFilter;
              });
        };
        var actPatternFilterStrUpdated = function (newPatternFilterStr) {
          setPatternFilterStr(function (param) {
                return newPatternFilterStr;
              });
        };
        var actDescrFilterStrUpdated = function (newDescrFilterStr) {
          setDescrFilterStr(function (param) {
                return newDescrFilterStr;
              });
        };
        var actDiscFilterUpdated = function (newDiscFilter) {
          setDiscFilter(function (param) {
                return newDiscFilter;
              });
        };
        var actDeprFilterUpdated = function (newDeprFilter) {
          setDeprFilter(function (param) {
                return newDeprFilter;
              });
        };
        var actTranDeprFilterUpdated = function (newTranDeprFilter) {
          setTranDeprFilter(function (param) {
                return newTranDeprFilter;
              });
        };
        var match$18 = React.useState(function () {
              return true;
            });
        var setIsFirstRender = match$18[1];
        var isFirstRender = match$18[0];
        React.useEffect((function () {
                setIsFirstRender(function (param) {
                      return false;
                    });
                if (!isFirstRender) {
                  actApplyFilters();
                }
                
              }), [
              isAxiomFilter,
              stmtTypeFilter,
              discFilter,
              deprFilter,
              tranDeprFilter
            ]);
        var actCloseMainMenu = function () {
          setMainMenuIsOpened(function (param) {
                return false;
              });
        };
        var actRenameThisTab = function () {
          MM_react_common.openModalPaneWithTitle(modalRef, "Rename tab", (function (close) {
                  return React.createElement(MM_cmp_rename_tab.make, {
                              initName: tabTitle,
                              onOk: (function (newName) {
                                  close();
                                  onTabTitleChange(newName);
                                }),
                              onCancel: close
                            });
                }));
        };
        var actOpenAsrtsPerPageDialog = function () {
          Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                      return null;
                    })), (function (modalId) {
                  Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                          return React.createElement(MM_cmp_asrts_per_page.make, {
                                      initAsrtsPerPage: String(asrtsPerPage),
                                      onOk: (function (strNum) {
                                          Expln_React_Modal.closeModal(modalRef, modalId);
                                          var num = Belt_Int.fromString(strNum);
                                          if (num !== undefined) {
                                            return setAsrtsPerPage(function (param) {
                                                        return Math.max(1, Math.min(num, 100));
                                                      });
                                          }
                                          
                                        }),
                                      onCancel: (function () {
                                          Expln_React_Modal.closeModal(modalRef, modalId);
                                        })
                                    });
                        }));
                }));
        };
        var rndIsAxiomFilter = function () {
          return React.createElement(FormControl, {
                      size: "small",
                      children: Caml_option.some(null)
                    }, React.createElement(InputLabel, {
                          id: "isAxiomFilter-label",
                          children: "Assertion type"
                        }), React.createElement(Select, {
                          sx: {
                            width: 130
                          },
                          labelId: "isAxiomFilter-label",
                          label: "Assertion type",
                          value: isAxiomFilterToStr(isAxiomFilter),
                          onChange: Expln_React_common.evt2str(actIsAxiomFilterUpdated),
                          children: Caml_option.some(null)
                        }, React.createElement(MenuItem, {
                              value: "none",
                              children: "All"
                            }), React.createElement(MenuItem, {
                              value: "true",
                              children: "Axiom"
                            }), React.createElement(MenuItem, {
                              value: "false",
                              children: "Theorem"
                            })));
        };
        var rndStmtTypeFilter = function () {
          return React.createElement(FormControl, {
                      size: "small",
                      children: Caml_option.some(null)
                    }, React.createElement(InputLabel, {
                          id: "stmtTypeFilter-label",
                          children: "Statement type"
                        }), React.createElement(Select, {
                          sx: {
                            width: 130
                          },
                          labelId: "stmtTypeFilter-label",
                          label: "Statement type",
                          value: stmtTypeFilter !== undefined ? stmtTypeFilter : allStmtTypesConcat,
                          onChange: Expln_React_common.evt2str(actStmtTypeFilterUpdated),
                          children: Caml_option.some(null)
                        }, React.createElement(MenuItem, {
                              value: allStmtTypesConcat,
                              children: "All"
                            }), allStmtTypes.map(function (stmtType) {
                              return JsxPPXReactSupportU.createElementWithKey(stmtType, MenuItem, {
                                          value: stmtType,
                                          children: Caml_option.some(stmtType)
                                        });
                            })));
        };
        var rndLabelFilter = function () {
          return React.createElement(TextField, {
                      value: labelFilter,
                      label: "Label",
                      size: "small",
                      style: {
                        width: "200px"
                      },
                      onChange: Expln_React_common.evt2str(actLabelFilterUpdated),
                      onKeyDown: MM_react_common.kbrdHnd(MM_react_common.keyEnter, undefined, undefined, undefined, actApplyFilters),
                      autoFocus: true
                    });
        };
        var rndPatternFilter = function () {
          return React.createElement(TextField, {
                      value: patternFilterStr,
                      label: "Pattern",
                      size: "small",
                      style: {
                        width: "300px"
                      },
                      onChange: Expln_React_common.evt2str(actPatternFilterStrUpdated),
                      onKeyDown: MM_react_common.kbrdHnd(MM_react_common.keyEnter, undefined, undefined, undefined, actApplyFilters)
                    });
        };
        var rndDescrFilter = function () {
          return React.createElement(TextField, {
                      value: descrFilterStr,
                      label: "Description",
                      size: "small",
                      style: {
                        width: "300px"
                      },
                      onChange: Expln_React_common.evt2str(actDescrFilterStrUpdated),
                      onKeyDown: MM_react_common.kbrdHnd(MM_react_common.keyEnter, undefined, undefined, undefined, actApplyFilters)
                    });
        };
        var rnd3StateCheckbox = function (label, style, checked, onChange) {
          return React.createElement(FormControlLabel, {
                      control: React.createElement(Checkbox, {
                            indeterminate: Core__Option.getOr(checked, true) === false,
                            checked: Core__Option.getOr(checked, false),
                            onChange: (function (param) {
                                if (checked !== undefined) {
                                  if (checked) {
                                    return onChange(false);
                                  } else {
                                    return onChange(undefined);
                                  }
                                } else {
                                  return onChange(true);
                                }
                              })
                          }),
                      label: label,
                      style: style
                    });
        };
        var rndDiscFilter = function () {
          return rnd3StateCheckbox("Discouraged", {
                      marginTop: "-2px",
                      marginLeft: "2px",
                      paddingRight: "10px"
                    }, discFilter, actDiscFilterUpdated);
        };
        var rndDeprFilter = function () {
          return rnd3StateCheckbox("Deprecated", {
                      marginTop: "-2px",
                      marginLeft: "2px",
                      paddingRight: "10px"
                    }, deprFilter, actDeprFilterUpdated);
        };
        var rndTranDeprFilter = function () {
          return rnd3StateCheckbox("Transitively deprecated", {
                      marginTop: "-2px",
                      marginLeft: "2px",
                      paddingRight: "10px"
                    }, tranDeprFilter, actTranDeprFilterUpdated);
        };
        var rndApplyFiltersBtn = function () {
          return React.createElement("span", {
                      title: "Apply filters"
                    }, React.createElement(IconButton, {
                          onClick: (function (param) {
                              actApplyFilters();
                            }),
                          color: "primary",
                          children: Caml_option.some(React.createElement(FilterAlt, {}))
                        }));
        };
        var rndClearFiltersBtn = function () {
          return React.createElement("span", {
                      title: "Clear filters"
                    }, React.createElement(IconButton, {
                          onClick: (function (param) {
                              var applyFilters = true;
                              setIsAxiomFilter(function (param) {
                                    
                                  });
                              setStmtTypeFilter(function (param) {
                                    
                                  });
                              setLabelFilter(function (param) {
                                    return "";
                                  });
                              setPatternFilterStr(function (param) {
                                    return "";
                                  });
                              setPatternFilterErr(function (param) {
                                    
                                  });
                              setDescrFilterStr(function (param) {
                                    return "";
                                  });
                              setDiscFilter(function (param) {
                                    
                                  });
                              setDeprFilter(function (param) {
                                    
                                  });
                              setTranDeprFilter(function (param) {
                                    
                                  });
                              if (applyFilters) {
                                return setApplyFiltersRequested(function (param) {
                                            return true;
                                          });
                              }
                              
                            }),
                          color: "primary",
                          children: Caml_option.some(React.createElement(FilterAltOff, {}))
                        }));
        };
        var rndMainMenuBtn = function () {
          return React.createElement("span", {
                      ref: Caml_option.some(mainMenuButtonRef),
                      title: "Additional actions"
                    }, React.createElement(IconButton, {
                          onClick: (function (param) {
                              setMainMenuIsOpened(function (param) {
                                    return true;
                                  });
                            }),
                          color: "primary",
                          children: Caml_option.some(React.createElement(Menu, {}))
                        }));
        };
        var rndFilters = function () {
          return React.createElement(Expln_React_Column.make, {
                      children: Caml_option.some(null)
                    }, React.createElement(Expln_React_Row.make, {
                          children: Caml_option.some(null)
                        }, rndIsAxiomFilter(), rndLabelFilter(), rndPatternFilter(), rndDescrFilter(), rndApplyFiltersBtn(), rndClearFiltersBtn(), rndMainMenuBtn()), React.createElement(Expln_React_Row.make, {
                          children: Caml_option.some(null)
                        }, rndStmtTypeFilter(), rndDiscFilter(), rndDeprFilter(), rndTranDeprFilter()));
        };
        var rndMainMenu = function () {
          if (!mainMenuIsOpened) {
            return React.createElement(React.Fragment, {});
          }
          var mainMenuButtonRef$1 = mainMenuButtonRef.current;
          if (mainMenuButtonRef$1 == null) {
            return React.createElement(React.Fragment, {});
          } else {
            return React.createElement(Expln_React_Menu.make, {
                        opn: true,
                        anchorEl: Caml_option.some(mainMenuButtonRef$1),
                        onClose: actCloseMainMenu,
                        children: Caml_option.some(null)
                      }, React.createElement(MenuItem, {
                            onClick: (function () {
                                setMainMenuIsOpened(function (param) {
                                      return false;
                                    });
                                openExplorer(undefined);
                              }),
                            children: "Open new Explorer tab"
                          }), React.createElement(MenuItem, {
                            onClick: (function () {
                                setMainMenuIsOpened(function (param) {
                                      return false;
                                    });
                                Belt_Option.forEach(Caml_option.nullable_to_opt(toggleCtxSelector.current), (function (toggleCtxSelector) {
                                        toggleCtxSelector();
                                      }));
                              }),
                            children: Caml_option.some(ctxSelectorIsExpanded ? "Hide context" : "Show context")
                          }), React.createElement(MenuItem, {
                            onClick: (function () {
                                setMainMenuIsOpened(function (param) {
                                      return false;
                                    });
                                actRenameThisTab();
                              }),
                            children: "Rename this tab"
                          }), React.createElement(MenuItem, {
                            onClick: (function () {
                                setMainMenuIsOpened(function (param) {
                                      return false;
                                    });
                                actOpenAsrtsPerPageDialog();
                              }),
                            children: Caml_option.some("Assertions per page: " + String(asrtsPerPage))
                          }));
          }
        };
        return React.createElement(Expln_React_Column.make, {
                    style: {
                      margin: "15px"
                    },
                    children: Caml_option.some(null)
                  }, rndFilters(), rndMainMenu(), refreshIsNeeded ? React.createElement(Button, {
                          onClick: (function (param) {
                              actRefreshOnPreCtxDataChange();
                            }),
                          variant: "contained",
                          children: "Refresh"
                        }) : (
                      patternFilterErr !== undefined ? React.createElement("pre", {
                              style: {
                                color: "red"
                              }
                            }, "Malformed pattern text: " + patternFilterErr) : (
                          allFramesInDeclarationOrder.length === 0 ? "The loaded context does not contain any assertions." : JsxPPXReactSupportU.createElementWithKey(String(preCtxData.ctxV.ver), MM_cmp_pe_frame_list.make, {
                                  modalRef: modalRef,
                                  typeColors: preCtxData.typeColors,
                                  editStmtsByLeftClick: preCtxData.settingsV.val.editStmtsByLeftClick,
                                  settings: preCtxData.settingsV.val,
                                  preCtx: preCtxData.ctxV.val.full,
                                  symColors: preCtxData.symColors,
                                  frms: preCtxData.frms,
                                  parenCnt: preCtxData.parenCnt,
                                  syntaxTypes: preCtxData.syntaxTypes,
                                  typeOrderInDisj: preCtxData.typeOrderInDisj,
                                  labels: match$15[0],
                                  openFrameExplorer: param.openFrameExplorer,
                                  openExplorer: openExplorer,
                                  asrtsPerPage: asrtsPerPage,
                                  addAsrtByLabel: (function (label) {
                                      var addAsrtByLabel$1 = addAsrtByLabel.current;
                                      if (addAsrtByLabel$1 !== undefined) {
                                        return addAsrtByLabel$1(label);
                                      } else {
                                        return Promise.resolve({
                                                    TAG: "Error",
                                                    _0: "Internal error: addAsrtByLabel is null"
                                                  });
                                      }
                                    })
                                })
                        )
                    ));
      }), propsAreSame);

exports.propsAreSame = propsAreSame;
exports.make = make;
/* make Not a pure module */
